import NeedsCloserLook from "components/card/needs-closer-look/NeedsCloserLook";
import ApplicationContainer from "components/application-container/ApplicationContainer";
import { useMarkApplicationSubmitted } from "hooks";

const NeedsCloserLookPage = () => {
    useMarkApplicationSubmitted();

    return (
        <>
            <title>Needs Closer Look | AAA Life</title>
            <ApplicationContainer useTitle={false} data-testid="needs-closer-look-page">
                <NeedsCloserLook />
            </ApplicationContainer>
        </>
    );
};

export default NeedsCloserLookPage;
